import Connector, { takeQuery } from '../../agent';
import types from './types';
import { goToErrorPage } from '../../utils';
import { put, takeEvery } from 'redux-saga/effects';
import { createQRStickersPDF } from '../../objects/QRStickerGridPdfCreator';
import { locationsActions } from './index';

const Locations = {
  getLocationAutocompleteList: ({ onlyBuildings }) =>
    Connector.api.get('/locations/autocomplete', null, { onlyBuildings }),
  getLocationAutocompleteSuggestions: ({ inputValue }) =>
    Connector.api.get('/locations/autocomplete/search', null, { value: inputValue }),
  getBuildingSummary: ({ buildingNum, id }) =>
    Connector.api.get(`/locations/buildingSummary`, false, { buildingNum, id }),
  getWatershedIdByLocation: ({ id }) => Connector.api.get(`/locations/watershedIdByLocation/${id}`),
  getWatershedByLocation: ({ id }) => Connector.api.get(`/locations/watershedByLocation/${id}`),
  getExperimentByLocation: ({ id }) => Connector.api.get(`/locations/experimentByLocation/${id}`),
  saveLocation: ({ saveDto }) => Connector.api.post('/locations', saveDto),
};

function* createPDF({
  params: {
    gridParameters,
    selectedBuildings,
    labelsSupplier,
    labelsSupplierResultMapper,
    urlTemplateFunction,
    downloadFileName,
    errorHandler
  }
}) {
  try {
    const labelsResult = yield labelsSupplier();
    const labels = labelsSupplierResultMapper(labelsResult);

    createQRStickersPDF(
      gridParameters,
      selectedBuildings,
      labels,
      urlTemplateFunction,
      downloadFileName ?? 'qr-stickers.pdf',
      errorHandler
    ).then(yield put(locationsActions.createBuildingsQRStickersPdfSuccess()));
  } catch (error) {
    yield put(locationsActions.createBuildingsQRStickersPdfFailure(error));
  }
}

const locationSagas = [
  takeQuery(types.GET_LOCATION_AUTOCOMPLETE_LIST, Locations.getLocationAutocompleteList),
  takeQuery(types.GET_LOCATION_AUTOCOMPLETE_SUGGESTIONS, Locations.getLocationAutocompleteSuggestions),
  takeQuery(types.GET_BUILDING_SUMMARY, {
    api: Locations.getBuildingSummary,
    notifyFailure: [goToErrorPage]
  }),
  takeQuery(types.GET_WATERSHED_ID_BY_LOCATION, Locations.getWatershedIdByLocation),
  takeQuery(types.GET_WATERSHED_BY_LOCATION, Locations.getWatershedByLocation),
  takeQuery(types.GET_EXPERIMENT_BY_LOCATION, Locations.getExperimentByLocation),
  takeQuery(types.SAVE, Locations.saveLocation),
  takeEvery(types.CREATE_BUILDINGS_QR_STICKERS_PDF, createPDF),

];

export default locationSagas;
